import React from 'react'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import "./LeftSidebar.css"
import { NavLink } from 'react-router-dom'
import Globe from '../../assets/globe16.png'
import useCheckMobileScreen from './useCheckMobileScreen'

const LeftSidebar = () => {

  
  var isMenu = useSelector((state) => (state.menuReducer));

  let isMobile = useCheckMobileScreen();

  if(isMobile) {
    
    if(isMenu) {
      return (
        <div className='left-sidebar'>
          <nav className='side-nav'>
            <NavLink to='/' className='side-nav-links' activeClassName='active' style={{height: "53px"}}> 
              Home
            </NavLink>
            <div className='side-nav-div'>
              <div><p>PUBLIC</p></div>
              <NavLink to='/Questions' className='side-nav-links' activeClassName='active' style={{paddingLeft: "10px"}}>
                <img src={Globe} alt='Globe' />
                <p style={{paddingLeft: "10px"}}>Questions</p>
              </NavLink>
              <NavLink to='/Tags' className='side-nav-links' activeClassName='active' style={{paddingLeft: "40px"}}>
                <p>Tags</p>
              </NavLink>
              <NavLink to='/Users' className='side-nav-links' activeClassName='active' style={{paddingLeft: "40px"}}>
                <p>Users</p>
              </NavLink>
              <Link to="/" className='side-nav-links' activeClassName='active' style={{paddingLeft: "40px"}}><p>About</p></Link>
              <Link to="/" className='side-nav-links' activeClassName='active' style={{paddingLeft: "40px"}}><p>Products</p></Link>
              <Link to="/" className='side-nav-links' activeClassName='active' style={{paddingLeft: "40px"}}><p>For Teams</p></Link>
            </div>
          </nav>
        </div>
      )
    }
    
  } else {
    return (
      <div className='left-sidebar'>
      <nav className='side-nav'>
        <NavLink to='/' className='side-nav-links' activeClassName='active' style={{height: "53px"}}> 
          Home
        </NavLink>
        <div className='side-nav-div'>
          <div><p>PUBLIC</p></div>
          <NavLink to='/Questions' className='side-nav-links' activeClassName='active' style={{paddingLeft: "10px"}}>
            <img src={Globe} alt='Globe' />
            <p style={{paddingLeft: "10px"}}>Questions</p>
          </NavLink>
          <NavLink to='/Tags' className='side-nav-links' activeClassName='active' style={{paddingLeft: "40px"}}>
            <p>Tags</p>
          </NavLink>
          <NavLink to='/Users' className='side-nav-links' activeClassName='active' style={{paddingLeft: "40px"}}>
            <p>Users</p>
          </NavLink>
        </div>
      </nav>
    </div>
    )
  }
  
}

export default LeftSidebar